import type { Table } from "@tanstack/react-table";
import type { DocumentRowFragment } from "../client/generated";
import { Button } from "@acdc2/ui/components/button";
import { mdiTuneVariant } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@acdc2/ui/components/dropdown-menu";

type Props = {
  table: Table<DocumentRowFragment>;
};

export function DocumentTableViewOptions({ table }: Props) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Icon path={mdiTuneVariant} size="1rem" />
          {t("DocumentTableViewOptions.label")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>
          {t("DocumentTableViewOptions.prompt")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table
          .getAllColumns()
          .filter((column) => !!column.accessorFn && column.getCanHide())
          .map((column) => (
            <DropdownMenuCheckboxItem
              key={column.id}
              checked={column.getIsVisible()}
              onCheckedChange={(checked) => column.toggleVisibility(checked)}
            >
              {column.id === "name"
                ? t("DocumentNameTableHeader.label")
                : column.id === "tags"
                  ? t("DocumentTagsTableHeader.label")
                  : column.id === "uploadedBy"
                    ? t("DocumentUploadedByTableHeader.label")
                    : column.id === "uploadedAt"
                      ? t("DocumentUploadedAtTableHeader.label")
                      : column.id === "modifiedBy"
                        ? t("DocumentModifiedByTableHeader.label")
                        : column.id === "modifiedAt"
                          ? t("DocumentModifiedAtTableHeader.label")
                          : column.id === "extension"
                            ? t("DocumentExtensionTableHeader.label")
                            : null}
            </DropdownMenuCheckboxItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
